// Default frame/signal data and small shared constants for the CAN
// Endianness Visualizer. Kept separate from calculation logic (bitMapping/
// decode/dbc/validation) and from the UI components.
import { computePhysicalRange } from './decode';

export const SIGNAL_COLORS = [
  '#2563eb', // blue
  '#059669', // emerald
  '#d97706', // amber
  '#db2777', // pink
  '#7c3aed', // violet
  '#0891b2', // cyan
  '#dc2626', // red
  '#65a30d', // lime
  '#9333ea', // purple
  '#0d9488', // teal
];

export function colorForIndex(index) {
  return SIGNAL_COLORS[index % SIGNAL_COLORS.length];
}

let idCounter = 0;
export function nextSignalId() {
  idCounter += 1;
  return `sig-${idCounter}-${Date.now().toString(36)}`;
}

export const DEFAULT_CAN_ID_HEX = '123';
export const DEFAULT_DLC = 8;
export const DEFAULT_DATA_HEX = ['11', '22', '33', '44', '55', '66', '77', '88'];
export const BLANK_DATA_HEX = ['00', '00', '00', '00', '00', '00', '00', '00'];

// Physical Min/Max are real, independently-editable fields on a signal (matching
// real .dbc files, where the documented physical range is not always identical to
// what the raw bit width could represent) — this fills in a sensible default (the
// bit-representable range) for a signal that doesn't specify its own yet.
function withDefaultPhysicalRange(signal) {
  if (Number.isFinite(signal.physicalMin) && Number.isFinite(signal.physicalMax)) return signal;
  const { min, max } = computePhysicalRange(signal);
  return { ...signal, physicalMin: signal.physicalMin ?? min, physicalMax: signal.physicalMax ?? max };
}

export function makeDefaultSignals() {
  return [
    { id: nextSignalId(), name: 'VehicleSpeed', startBit: 16, length: 16, byteOrder: 'intel', signed: false, factor: 0.01, offset: 0, unit: 'km/h' },
    { id: nextSignalId(), name: 'AmbientTemperature', startBit: 32, length: 8, byteOrder: 'intel', signed: false, factor: 1, offset: -40, unit: '°C' },
    { id: nextSignalId(), name: 'IgnitionStatus', startBit: 40, length: 1, byteOrder: 'intel', signed: false, factor: 1, offset: 0, unit: 'ON/OFF' },
  ].map(withDefaultPhysicalRange);
}

export function makeBlankSignal(overrides = {}) {
  const base = {
    id: nextSignalId(),
    name: '',
    startBit: 0,
    length: 8,
    byteOrder: 'intel',
    signed: false,
    factor: 1,
    offset: 0,
    unit: '',
    ...overrides,
  };
  return withDefaultPhysicalRange(base);
}
